/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddStockTakeDto as DigiworkMaitreDPosDtoInventoryStockTakeAddStockTakeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/add-stock-take-dto';
import { InventoryStockTakeDto as DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';

export interface AddInventoryStockTake$Params {
  inventoryId: string;
      body?: DigiworkMaitreDPosDtoInventoryStockTakeAddStockTakeDto
}

export function addInventoryStockTake(http: HttpClient, rootUrl: string, params: AddInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
  const rb = new RequestBuilder(rootUrl, addInventoryStockTake.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>;
    })
  );
}

addInventoryStockTake.PATH = '/api/inventories/{inventoryId}/stock-takes';
